import {
	getHttpClient,
	NonCustodialProviderManagementApi,
	TokenSupportingPlatformApi,
	WalletApi
} from '@capsicum/common';

export const ncWalletApi = getHttpClient.then(client => new NonCustodialProviderManagementApi(client));
export const walletApi = getHttpClient.then(c => new WalletApi(c));
export const tokenSupportingPlantformApi = getHttpClient.then(client => new TokenSupportingPlatformApi(client));
